












































import axios, { AxiosError } from 'axios';
import { use } from 'chai';
import { Component, Watch } from 'vue-property-decorator';

import DialogBase from '@/components/common/DialogBase';
import loginUser from '@/store/modules/LoginUserModule';

interface OwnFile {
  uuid: number;
  fileName: string;
  createDate: string;
}
@Component({
  components: {},
})
export default class OwnFileListDialog extends DialogBase {
  private ownFileList: OwnFile[] = [];

  private async created() {
    this.init();
  }

  @Watch('innerValue')
  private innerValueChanged(val: boolean) {
    // dialogが開いたので再初期化
    if (val) {
      this.init();
    }
  }

  // 指定されたpdfのページのリンクを取得
  private getPdfPageUrl(fileId: string): string {
    return location.origin + '/home/pdf?id=' + fileId;
  }

  private async init() {
    const user = loginUser.loginUser?.userAccount ?? ''; // nullでreturnをすると開発時にmockが動かないので空文字にしておく。
    let res;
    try {
      res = await axios.get(`/api/pdf/own`);
      console.log('res', res);
      this.ownFileList = res.data.ownFileList;
    } catch (e) {
      console.log(`created: error=${e}`);
      this.ownFileList = [];
    }
  }
}
